import { NotificationActionTypes } from './../action/index';
import { NotificationState, initialState } from "../state/NotificationState";
import { NotificationActions, DispatchedNotificationAction } from "../action/NotificationActions";
import { NotificationModel } from '../../model/NotificationModel';

export function notificationReducer(state: NotificationState = initialState, action: NotificationActions): NotificationState {
    switch (action.type) {
        case NotificationActionTypes.CLEAR:
            return {...state, loading: false, error: false, data: null, loadingGet: false, errorGet: false, item: null };
        case NotificationActionTypes.CLEAR_ERRORS:
            return {...state, loading: false, error: false, loadingGet: false, errorGet: false };
        case NotificationActionTypes.LIST:
            return {...state, loading: true, error: false };
        case NotificationActionTypes.LIST_SUCCESS:
            let newData: Array<NotificationModel> = new Array<NotificationModel>();
            let oldData: Array<NotificationModel> = new Array<NotificationModel>();
            if (state.data != null) {
                newData = state.data;
            }
            action.data.forEach(item => {
                let newDataItem = newData.find(x => x.id == item.id);
                if (newDataItem == null) {
                    newData.push(item);
                } else {
                    newDataItem.status = item.status;
                    if (item.status > 1) {
                        oldData.push(item);
                    }
                }
            });
            return {...state, loading: false, error: false, data: newData, readData: oldData };
        case NotificationActionTypes.LIST_ERROR:
            return {...state, loading: false, error: true };
        case NotificationActionTypes.GET:
            return {...state, loadingGet: true, errorGet: false, item: null };
        case NotificationActionTypes.GET_SUCCESS:
            return {...state, loadingGet: false, errorGet: false, item: action.item };
        case NotificationActionTypes.GET_ERROR:
            return {...state, loadingGet: false, errorGet: true, item: null };
        case NotificationActionTypes.RENEW:
            return {...state, loadingRenew: true, errorRenew: false };
        case NotificationActionTypes.RENEW_SUCCESS:
            let newData1: Array<NotificationModel> = new Array<NotificationModel>();
            let oldData1: Array<NotificationModel> = new Array<NotificationModel>();
            if (state.data != null) {
                newData1 = state.data;
            }
            action.data.forEach(item => {
                let newDataItem1 = newData1.find(x => x.id == item.id);
                if (newDataItem1 == null) {
                    newData1.push(item);
                } else {
                    newDataItem1.status = item.status;
                    if (item.status > 1) {
                        oldData1.push(item);
                    }
                }
            });
            return {...state, loadingRenew: false, errorRenew: false, data: newData1, readData: oldData1 };
        case NotificationActionTypes.RENEW_ERROR:
            return {...state, loadingRenew: false, errorRenew: true };
        case NotificationActionTypes.DISPATCH:
            const dispatchAction = action as DispatchedNotificationAction;
            let newData2: Array<NotificationModel> = state.data;
            newData2.forEach(item => {
                if (item.id == dispatchAction.payload.id) {
                    item.notified = true;
                    item.notificationObject = dispatchAction.payload.notificationObject;
                }
            });
            return {...state, data: newData2};
        default:
            return {...state};
    }
}


// WEBPACK FOOTER //
// ./src/store/reducer/NotificationReducer.ts